module.exports = __webpack_public_path__ + "static/media/3008.c0837ec7.png";